<template>
  <div class="next-period-box">
    <Grid gaf="column" justify-content="space-between">
      <div class="text-secondary-1">
        <div v-if="nextPeriod.normalized_price" class="text-heading-1">
          {{ nextPeriod.normalized_currency }}
          {{ formatPrice(nextPeriod.normalized_price, 2) }}
        </div>

        <div v-else class="text-body-3 text-grey3 q-mt-sm">
          {{ nextPeriod.normalized_currency }}
          N/A
        </div>

        <div v-if="nextPeriod.price" class="text-heading-5">
          {{ nextPeriod.currency }}
          {{ formatPrice(nextPeriod.price, 2) }}
        </div>

        <div v-else class="text-body-3 text-grey3">
          {{ nextPeriod.currency }}
          N/A
        </div>

        <div class="text-body-1 text-grey3 q-pt-sm">{{ nextPeriod.name_reference }}</div>
      </div>

      <Grid justify-items="end" align-content="start" class="q-mt-xs">
        <div v-if="shouldShowDecisionDeadline" class="text-caption-1 text-secondary-1 q-mb-xs">
          Decision deadline: {{ decisionDeadline }}
        </div>

        <Grid gap="var(--r-space-sm)" justify-items="center">
          <div v-if="nextPeriod.status.name === 'accepted'" class="text-caption-3 text-success-1 accepted-text">
            accepted
          </div>

          <template v-for="(action, key) in nextPeriod.actions">
            <RBtn
              v-if="key !== 'accept' || (key === 'accept' && nextPeriod.status.name !== 'accepted')"
              :key="key"
              :type="key === 'cancel' ? 'tertiary' : 'primary'"
              size="small"
              @click="updateSubscription(key)"
            >
              {{ action.label }}
            </RBtn>
          </template>
        </Grid>
      </Grid>
    </Grid>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters('subscription-show', ['subscription']),

    nextPeriod() {
      return this.subscription?.next
    },

    decisionDeadline() {
      if (!this.nextPeriod?.cancellation_deadline) return
      return moment(this.nextPeriod.cancellation_deadline).format('MMMM Do, YYYY')
    },

    shouldShowDecisionDeadline() {
      /* Logic -> https://app.clubhouse.io/subscriptionpeople/story/11628/when-and-where-to-show-must-cancel-by-date-in-subscriptions-header */
      if (!this.decisionDeadline) return false
      if (!this.subscription?.current) return false
      if (this.nextPeriod?.status.name !== 'pending') return false
      if (this.nextPeriod?.one_time_purchase) return false

      return true
    }
  },

  methods: {
    ...mapMutations('subscription-show', ['setSubscription', 'updatePeriod']),

    updateSubscription(action) {
      const periodId = this.nextPeriod.id

      apiTo.MODIFY_SUBSCRIPTION_PERIOD(periodId, { [action]: true }).then(({ data }) => {
        this.updatePeriod(data.result)
        this.updateWorkflow(action)
        apiTo.GET_SUBSCRIPTION(this.subscription.id).then(({ data }) => this.setSubscription(data.result))
      })
    },

    updateWorkflow(action) {
      if (!['accept', 'cancel'].includes(action)) return

      this.$root.$emit('refresh-workflow', { task: 'decisions' })
      this.$root.$emit('refresh-milestones-data', {
        periodId: this.nextPeriod.id,
        milestone: 'decisions'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.next-period-box {
  .accepted-text {
    height: var(--r-space-xl);
    line-height: var(--r-space-xl);
  }
}
</style>
